/* eslint-disable */
export default {
  unknown: 'Unknown',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
